import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { media } from '@amtrav/themes';
import { getTokenValue, THEME_TOKENS } from '@amtrav/theme-system';

export const AccountSetupPage = styled(Flex)`
  background: ${getTokenValue(THEME_TOKENS.navigation.color.sectionBackground)};
  height: auto;
`;

export const SignUpContent = styled(Flex)`
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 0px 12px;

  ${media.Large`
    width: 624px;
    padding-top: 50px;
  `};

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    display: block;
  }
`;

export const FormRow = styled(Flex)`
  gap: 0;

  ${media.Medium`
    gap: 8px;
  `};
`;

export const ConfirmSignUp = styled(Flex)`
  gap: 24px;
`;

export const FlexGap = styled(Flex)`
  gap: ${({ gap }) => gap || 0};
`;

export const IntroMessage = styled(Box)`
  font-size: 16px;
  text-align: center;
  line-height: 1.4;
  margin: 0 auto;
  padding: 16px;
  color: ${getTokenValue(THEME_TOKENS.base.color.primaryText)};
  ${media.Large`
    font-size: 20px;
  `};
`;
